import { useContactChannelsContext as f } from "./contact-channels19.js";
import { useRecaptchaContext as A } from "./contact-channels69.js";
import { NRLogger as s } from "./contact-channels45.js";
import { attempt as i } from "./contact-channels54.js";
import { useMutation as d } from "./contact-channels92.js";
const S = () => {
  const { locale: e, tenant: u, origin: t, auth: n } = f(), { getRecaptchaToken: m } = A();
  return d({ mutationKey: ["emailActions"], mutationFn: async (c) => {
    const { data: p, error: C } = c.skipRecaptcha ? { data: "", error: null } : await i(m()), a = c.caseType;
    if (C)
      return s.error("Contact Channels: Recaptcha", {
        ...C,
        locale: e,
        action: "CreateEmailCase",
        caseType: a,
        origin: t
      }), {
        success: !1,
        error: "RECAPTCHA_ERROR"
      };
    const { data: o, error: l } = await i(
      fetch(`https://help-case-creation-service.care.vpsvc.com/v1/case/origins/${a}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json, text/plain, */*",
          Authorization: (n == null ? void 0 : n.getAuthorizationHeader()) || "",
          "x-requestor": t || "unset",
          ...p ? { "x-recap-token": p } : {}
        },
        body: JSON.stringify({
          locale: e,
          tenant: u,
          origin: t,
          ...c
        })
      })
    );
    if (l)
      return s.error("Contact Channels: Email Actions", {
        ...l,
        type: "REQUEST_ERROR",
        caseType: a,
        action: "CreateEmailCase",
        locale: e,
        origin: t
      }), {
        success: !1,
        error: "INTERNAL_ERROR"
      };
    if (!o.ok) {
      const E = await o.text(), { data: r } = i(() => JSON.parse(E)), h = (r == null ? void 0 : r.code) || "INTERNAL_ERROR";
      return s.error("Contact Channels: Email Actions", {
        status: o.status,
        ...r,
        type: "BAD_RESPONSE",
        caseType: a,
        action: "CreateEmailCase",
        locale: e,
        origin: t
      }), {
        success: !1,
        error: h
      };
    }
    const R = await o.json();
    return s.info("Contact Channels: Email Actions", {
      status: o.status,
      caseType: a,
      action: "CreateEmailCase",
      locale: e,
      origin: t
    }), {
      success: !0,
      data: R
    };
  } });
};
export {
  S as useCreateCase
};
//# sourceMappingURL=contact-channels60.js.map
